module.exports = __webpack_public_path__ + "img/ui3.ddb46cff.svg";